'use client';

import classNames from 'classnames';
import { FunctionComponent, useContext, useEffect, useState } from 'react';

import CrossIcon from '@/app/components/CrossIcon/CrossIcon';
import { ToastContext, ToastType } from '@/app/providers/ToastProvider';

export type ToastProps = { toast: ToastType | null };

const Toast: FunctionComponent<ToastProps> = ({ toast }) => {
  const { setToast } = useContext(ToastContext);
  const [message, setMessage] = useState<string>();

  useEffect(() => {
    if (toast) {
      setMessage(toast.message);
    }
  }, [toast]);

  return (
    <div
      data-cy="toast"
      className={classNames(
        'transition transform ease-in-out duration-500 fixed -top-12 left-0 right-0 mx-auto flex items-center w-full max-w-xs h-auto p-4 gap-4 text-sm font-normal border border-neutral-white rounded-2xl text-neutral-light',
        {
          'bg-success-mid': toast?.type === 'success',
          'bg-warning': toast?.type === 'error',
          'bg-secondary-mid': toast?.type === 'warning',
          'translate-y-20 z-[200] opacity-100 ': toast,
          'translate-y-0 z-0 opacity-0 ': !toast,
        },
      )}
    >
      <p className="font-normal text-neutral-light">{message}</p>
      <button data-ga="close-toast" type="button" className="ml-auto" onClick={() => setToast(null)}>
        <CrossIcon className="fill-white w-4 h-4" />
      </button>
    </div>
  );
};

export default Toast;
